export default "__VITE_ASSET__iNvvnRCJ__"